// node modules
import React from 'react';

// app modules: components
import Layout from 'components/Layout';
import CollectionView from './CollectionView';

async function action(_, params) {
  return {
    chunks: ['collection'],
    title: 'Collection',
    navigation: {
      heading: 'Collections',
      section: 'Collections',
      left: 'back',
    },
    component: (
      <Layout type="full" withLeaderboardAd={false} overlayPromoBanner>
        <CollectionView id={params.id} type={params.type} shareKey={params.key} />
      </Layout>
    ),
  };
}

export default action;
